export const sibFinDataLc = [
    { id: 72, pitch: 14.1, thickness: 3.9 },
    { id: 73, pitch: 13.4, thickness: 3.9 },
    { id: 74, pitch: 12.7, thickness: 3.9 },
    { id: 75, pitch: 12.1, thickness: 3.9 },
    { id: 76, pitch: 11.5, thickness: 3.9 },
    { id: 77, pitch: 11.0, thickness: 3.9 },
    { id: 78, pitch: 10.6, thickness: 3.9 },
    { id: 79, pitch: 10.2, thickness: 3.9 },
    { id: 202, pitch: 14.1, thickness: 3.9 },
    { id: 203, pitch: 13.4, thickness: 3.9 },
    { id: 204, pitch: 12.7, thickness: 3.9 },
    { id: 205, pitch: 12.1, thickness: 3.9 },
    { id: 206, pitch: 11.5, thickness: 3.9 },
    { id: 207, pitch: 11.0, thickness: 3.9 },
    { id: 208, pitch: 10.6, thickness: 3.9 },
    { id: 209, pitch: 10.2, thickness: 3.9 }
]

export const siFinDataLc = [
    { id: 72, pitch: 1.8, thickness: 0.1 },
    { id: 73, pitch: 1.9, thickness: 0.1 },
    { id: 74, pitch: 2.0, thickness: 0.1 },
    { id: 75, pitch: 2.1, thickness: 0.1 },
    { id: 76, pitch: 2.2, thickness: 0.1 },
    { id: 77, pitch: 2.3, thickness: 0.1 },
    { id: 78, pitch: 2.4, thickness: 0.1 },
    { id: 79, pitch: 2.5, thickness: 0.1 },
]

export const sibFinDataLhp = [
    { id: 44, pitch: 14.1, thickness: 3.9 },
    { id: 45, pitch: 13.4, thickness: 3.9 },
    { id: 46, pitch: 12.7, thickness: 3.9 },
    { id: 47, pitch: 12.1, thickness: 3.9 },
    { id: 48, pitch: 11.5, thickness: 3.9 },
    { id: 49, pitch: 11.0, thickness: 3.9 },
    { id: 50, pitch: 10.6, thickness: 3.9 },
    { id: 51, pitch: 10.2, thickness: 3.9 },
    { id: 52, pitch: 9.8, thickness: 4.7 },
    { id: 53, pitch: 9.4, thickness: 4.7 },
    { id: 54, pitch: 9.1, thickness: 4.7 },
    { id: 55, pitch: 8.8, thickness: 4.7 },
    { id: 56, pitch: 8.5, thickness: 4.7 },
    { id: 57, pitch: 8.2, thickness: 4.7 },
    { id: 58, pitch: 7.9, thickness: 4.7 },
    { id: 59, pitch: 7.7, thickness: 4.7 },
    { id: 60, pitch: 7.5, thickness: 4.7 },
    { id: 61, pitch: 7.3, thickness: 4.7 },
    { id: 62, pitch: 7.1, thickness: 5.9 },
    { id: 63, pitch: 6.9, thickness: 5.9 },
    { id: 64, pitch: 6.7, thickness: 5.9 },
    { id: 65, pitch: 6.5, thickness: 5.9 },
    { id: 66, pitch: 6.3, thickness: 5.9 },
    { id: 67, pitch: 6.2, thickness: 5.9 },
    { id: 68, pitch: 6.0, thickness: 5.9 },
    { id: 69, pitch: 5.9, thickness: 5.9 },
    { id: 70, pitch: 5.8, thickness: 5.9 },
    { id: 71, pitch: 5.6, thickness: 5.9 },
    { id: 174, pitch: 14.1, thickness: 3.9 },
    { id: 175, pitch: 13.4, thickness: 3.9 },
    { id: 176, pitch: 12.7, thickness: 3.9 },
    { id: 177, pitch: 12.1, thickness: 3.9 },
    { id: 178, pitch: 11.5, thickness: 3.9 },
    { id: 179, pitch: 11.0, thickness: 3.9 },
    { id: 180, pitch: 10.6, thickness: 3.9 },
    { id: 181, pitch: 10.2, thickness: 3.9 },
    { id: 182, pitch: 9.8, thickness: 4.7 },
    { id: 183, pitch: 9.4, thickness: 4.7 },
    { id: 184, pitch: 9.1, thickness: 4.7 },
    { id: 185, pitch: 8.8, thickness: 4.7 },
    { id: 186, pitch: 8.5, thickness: 4.7 },
    { id: 187, pitch: 8.2, thickness: 4.7 },
    { id: 188, pitch: 7.9, thickness: 4.7 },
    { id: 189, pitch: 7.7, thickness: 4.7 },
    { id: 190, pitch: 7.5, thickness: 4.7 },
    { id: 191, pitch: 7.3, thickness: 4.7 },
    { id: 192, pitch: 7.1, thickness: 5.9 },
    { id: 193, pitch: 6.9, thickness: 5.9 },
    { id: 194, pitch: 6.7, thickness: 5.9 },
    { id: 195, pitch: 6.5, thickness: 5.9 },
    { id: 196, pitch: 6.3, thickness: 5.9 },
    { id: 197, pitch: 6.2, thickness: 5.9 },
    { id: 198, pitch: 6.0, thickness: 5.9 },
    { id: 199, pitch: 5.9, thickness: 5.9 },
    { id: 200, pitch: 5.8, thickness: 5.9 },
    { id: 201, pitch: 5.6, thickness: 5.9 }
]

export const siFinDataLhp = [
    { id: 44, pitch: 1.8, thickness: 0.1 },
    { id: 45, pitch: 1.9, thickness: 0.1 },
    { id: 46, pitch: 2.0, thickness: 0.1 },
    { id: 47, pitch: 2.1, thickness: 0.1 },
    { id: 48, pitch: 2.2, thickness: 0.1 },
    { id: 49, pitch: 2.3, thickness: 0.1 },
    { id: 50, pitch: 2.4, thickness: 0.1 },
    { id: 51, pitch: 2.5, thickness: 0.1 },
    { id: 52, pitch: 2.6, thickness: 0.1 },
    { id: 53, pitch: 2.7, thickness: 0.1 },
    { id: 54, pitch: 2.8, thickness: 0.1 },
    { id: 55, pitch: 2.9, thickness: 0.1 },
    { id: 56, pitch: 3.0, thickness: 0.1 },
    { id: 57, pitch: 3.1, thickness: 0.1 },
    { id: 58, pitch: 3.2, thickness: 0.1 },
    { id: 59, pitch: 3.3, thickness: 0.1 },
    { id: 60, pitch: 3.4, thickness: 0.1 },
    { id: 61, pitch: 3.5, thickness: 0.1 },
    { id: 62, pitch: 3.6, thickness: 0.2 },
    { id: 63, pitch: 3.7, thickness: 0.2 },
    { id: 64, pitch: 3.8, thickness: 0.2 },
    { id: 65, pitch: 3.9, thickness: 0.2 },
    { id: 66, pitch: 4.0, thickness: 0.2 },
    { id: 67, pitch: 4.1, thickness: 0.2 },
    { id: 68, pitch: 4.2, thickness: 0.2 },
    { id: 69, pitch: 4.3, thickness: 0.2 },
    { id: 70, pitch: 4.4, thickness: 0.2 },
    { id: 71, pitch: 4.5, thickness: 0.2 },
    { id: 174, pitch: 1.8, thickness: 0.1 },
    { id: 175, pitch: 1.9, thickness: 0.1 },
    { id: 176, pitch: 2.0, thickness: 0.1 },
    { id: 177, pitch: 2.1, thickness: 0.1 },
    { id: 178, pitch: 2.2, thickness: 0.1 },
    { id: 179, pitch: 2.3, thickness: 0.1 },
    { id: 180, pitch: 2.4, thickness: 0.1 },
    { id: 181, pitch: 2.5, thickness: 0.1 },
    { id: 182, pitch: 2.6, thickness: 0.1 },
    { id: 183, pitch: 2.7, thickness: 0.1 },
    { id: 184, pitch: 2.8, thickness: 0.1 },
    { id: 185, pitch: 2.9, thickness: 0.1 },
    { id: 186, pitch: 3.0, thickness: 0.1 },
    { id: 187, pitch: 3.1, thickness: 0.1 },
    { id: 188, pitch: 3.2, thickness: 0.1 },
    { id: 189, pitch: 3.3, thickness: 0.1 },
    { id: 190, pitch: 3.4, thickness: 0.1 },
    { id: 191, pitch: 3.5, thickness: 0.1 },
    { id: 192, pitch: 3.6, thickness: 0.2 },
    { id: 193, pitch: 3.7, thickness: 0.2 },
    { id: 194, pitch: 3.8, thickness: 0.2 },
    { id: 195, pitch: 3.9, thickness: 0.2 },
    { id: 196, pitch: 4.0, thickness: 0.2 },
    { id: 197, pitch: 4.1, thickness: 0.2 },
    { id: 198, pitch: 4.2, thickness: 0.2 },
    { id: 199, pitch: 4.3, thickness: 0.2 },
    { id: 200, pitch: 4.4, thickness: 0.2 },
    { id: 201, pitch: 4.5, thickness: 0.2 }
]

export const sibFinDataAcc = [
    { id: 44, pitch: 14.1, thickness: 3.9 },
    { id: 45, pitch: 13.4, thickness: 3.9 },
    { id: 46, pitch: 12.7, thickness: 3.9 },
    { id: 47, pitch: 12.1, thickness: 3.9 },
    { id: 48, pitch: 11.5, thickness: 3.9 },
    { id: 49, pitch: 11.0, thickness: 3.9 },
    { id: 50, pitch: 10.6, thickness: 3.9 },
    { id: 51, pitch: 10.2, thickness: 3.9 },
    { id: 52, pitch: 9.8, thickness: 4.7 },
    { id: 53, pitch: 9.4, thickness: 4.7 },
    { id: 54, pitch: 9.1, thickness: 4.7 },
    { id: 55, pitch: 8.8, thickness: 4.7 },
    { id: 56, pitch: 8.5, thickness: 4.7 },
    { id: 57, pitch: 8.2, thickness: 4.7 },
    { id: 58, pitch: 7.9, thickness: 4.7 },
    { id: 59, pitch: 7.7, thickness: 4.7 },
    { id: 60, pitch: 7.5, thickness: 4.7 },
    { id: 61, pitch: 7.3, thickness: 4.7 },
    { id: 62, pitch: 7.1, thickness: 5.9 },
    { id: 63, pitch: 6.9, thickness: 5.9 },
    { id: 64, pitch: 6.7, thickness: 5.9 },
    { id: 65, pitch: 6.5, thickness: 5.9 },
    { id: 66, pitch: 6.3, thickness: 5.9 },
    { id: 67, pitch: 6.2, thickness: 5.9 },
    { id: 68, pitch: 6.0, thickness: 5.9 },
    { id: 69, pitch: 5.9, thickness: 5.9 },
    { id: 70, pitch: 5.8, thickness: 5.9 },
    { id: 71, pitch: 5.6, thickness: 5.9 },
    { id: 174, pitch: 14.1, thickness: 3.9 },
    { id: 175, pitch: 13.4, thickness: 3.9 },
    { id: 176, pitch: 12.7, thickness: 3.9 },
    { id: 177, pitch: 12.1, thickness: 3.9 },
    { id: 178, pitch: 11.5, thickness: 3.9 },
    { id: 179, pitch: 11.0, thickness: 3.9 },
    { id: 180, pitch: 10.6, thickness: 3.9 },
    { id: 181, pitch: 10.2, thickness: 3.9 },
    { id: 182, pitch: 9.8, thickness: 4.7 },
    { id: 183, pitch: 9.4, thickness: 4.7 },
    { id: 184, pitch: 9.1, thickness: 4.7 },
    { id: 185, pitch: 8.8, thickness: 4.7 },
    { id: 186, pitch: 8.5, thickness: 4.7 },
    { id: 187, pitch: 8.2, thickness: 4.7 },
    { id: 188, pitch: 7.9, thickness: 4.7 },
    { id: 189, pitch: 7.7, thickness: 4.7 },
    { id: 190, pitch: 7.5, thickness: 4.7 },
    { id: 191, pitch: 7.3, thickness: 4.7 },
    { id: 192, pitch: 7.1, thickness: 5.9 },
    { id: 193, pitch: 6.9, thickness: 5.9 },
    { id: 194, pitch: 6.7, thickness: 5.9 },
    { id: 195, pitch: 6.5, thickness: 5.9 },
    { id: 196, pitch: 6.3, thickness: 5.9 },
    { id: 197, pitch: 6.2, thickness: 5.9 },
    { id: 198, pitch: 6.0, thickness: 5.9 },
    { id: 199, pitch: 5.9, thickness: 5.9 },
    { id: 200, pitch: 5.8, thickness: 5.9 },
    { id: 201, pitch: 5.6, thickness: 5.9 }
]

export const siFinDataAcc = [
    { id: 44, pitch: 1.8, thickness: 0.1 },
    { id: 45, pitch: 1.9, thickness: 0.1 },
    { id: 46, pitch: 2.0, thickness: 0.1 },
    { id: 47, pitch: 2.1, thickness: 0.1 },
    { id: 48, pitch: 2.2, thickness: 0.1 },
    { id: 49, pitch: 2.3, thickness: 0.1 },
    { id: 50, pitch: 2.4, thickness: 0.1 },
    { id: 51, pitch: 2.5, thickness: 0.1 },
    { id: 52, pitch: 2.6, thickness: 0.1 },
    { id: 53, pitch: 2.7, thickness: 0.1 },
    { id: 54, pitch: 2.8, thickness: 0.1 },
    { id: 55, pitch: 2.9, thickness: 0.1 },
    { id: 56, pitch: 3.0, thickness: 0.1 },
    { id: 57, pitch: 3.1, thickness: 0.1 },
    { id: 58, pitch: 3.2, thickness: 0.1 },
    { id: 59, pitch: 3.3, thickness: 0.1 },
    { id: 60, pitch: 3.4, thickness: 0.1 },
    { id: 61, pitch: 3.5, thickness: 0.1 },
    { id: 62, pitch: 3.6, thickness: 0.2 },
    { id: 63, pitch: 3.7, thickness: 0.2 },
    { id: 64, pitch: 3.8, thickness: 0.2 },
    { id: 65, pitch: 3.9, thickness: 0.2 },
    { id: 66, pitch: 4.0, thickness: 0.2 },
    { id: 67, pitch: 4.1, thickness: 0.2 },
    { id: 68, pitch: 4.2, thickness: 0.2 },
    { id: 69, pitch: 4.3, thickness: 0.2 },
    { id: 70, pitch: 4.4, thickness: 0.2 },
    { id: 71, pitch: 4.5, thickness: 0.2 },
    { id: 174, pitch: 1.8, thickness: 0.1 },
    { id: 175, pitch: 1.9, thickness: 0.1 },
    { id: 176, pitch: 2.0, thickness: 0.1 },
    { id: 177, pitch: 2.1, thickness: 0.1 },
    { id: 178, pitch: 2.2, thickness: 0.1 },
    { id: 179, pitch: 2.3, thickness: 0.1 },
    { id: 180, pitch: 2.4, thickness: 0.1 },
    { id: 181, pitch: 2.5, thickness: 0.1 },
    { id: 182, pitch: 2.6, thickness: 0.1 },
    { id: 183, pitch: 2.7, thickness: 0.1 },
    { id: 184, pitch: 2.8, thickness: 0.1 },
    { id: 185, pitch: 2.9, thickness: 0.1 },
    { id: 186, pitch: 3.0, thickness: 0.1 },
    { id: 187, pitch: 3.1, thickness: 0.1 },
    { id: 188, pitch: 3.2, thickness: 0.1 },
    { id: 189, pitch: 3.3, thickness: 0.1 },
    { id: 190, pitch: 3.4, thickness: 0.1 },
    { id: 191, pitch: 3.5, thickness: 0.1 },
    { id: 192, pitch: 3.6, thickness: 0.2 },
    { id: 193, pitch: 3.7, thickness: 0.2 },
    { id: 194, pitch: 3.8, thickness: 0.2 },
    { id: 195, pitch: 3.9, thickness: 0.2 },
    { id: 196, pitch: 4.0, thickness: 0.2 },
    { id: 197, pitch: 4.1, thickness: 0.2 },
    { id: 198, pitch: 4.2, thickness: 0.2 },
    { id: 199, pitch: 4.3, thickness: 0.2 },
    { id: 200, pitch: 4.4, thickness: 0.2 },
    { id: 201, pitch: 4.5, thickness: 0.2 }
]

// Backward compatibility exports (default to LC)
export const sibFinData = sibFinDataLc
export const siFinData = siFinDataLc
// Backward compatibility for LHP/ACC (use LHP)
export const sibFinDataLhpAcc = sibFinDataLhp
export const siFinDataLhpAcc = siFinDataLhp